import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-tax',
  imports: [UnderConstructionComponent],
  templateUrl: './tax.component.html'
})
export class TaxComponent {}
